import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable()
export class CookieService {
  /*
   * Indicates default cookie expiration days
   **/
  public static COOKIE_EXPIRATION = 360;

  /*
   * Indicates default cookie key
   **/
  public static COOKIE_NAME = '_cls';

  constructor(
    @Inject(DOCUMENT) private doc: any,
    @Inject(PLATFORM_ID) private platform: object,
  ) {
  }

  public isSeen(cookieName: string = CookieService.COOKIE_NAME): boolean {
    let cookies: string[] = [];

    if (isPlatformBrowser(this.platform)) {
      cookies = this.doc.cookie.split(';');

      return this.cookieExists(cookieName, cookies);
    }

    return true;
  }

  public storeCookie(
    cookieName: string = CookieService.COOKIE_NAME,
    expiration: number = CookieService.COOKIE_EXPIRATION,
  ): void {
    return this.setCookie(cookieName, expiration);
  }

  private cookieExists(name: string, cookies: string[]): boolean {
    const cookieName = `${name}=`;

    return cookies.reduce(
      (prev, curr) => prev || curr.trim().search(cookieName) > -1,
      false,
    );
  }

  private setCookie(name: string, expiration?: number): void {
    const now: Date = new Date();
    const exp: Date = new Date(now.getTime() + expiration * 86400000);

    const cookieString =
      encodeURIComponent(name) + `=true;path=/;expires=${exp.toUTCString()};`;

    if (isPlatformBrowser(this.platform)) {
      this.doc.cookie = cookieString;
    }
  }
}
